export default __webpack_public_path__ + "pgnv-assets/cc8cacc5bc2668333901a63517e403ea.png";